export const cardReaderStyles = `
:root {
  --flipcard-readmode-flipbtn-color: #9393f1;
  --flipcard-readmode-flipbtn-hover-color: #56548d;
}

/* Container en mode lecture */
.flipcard-container.reader-mode {
  width: 320px;
  height: 352px;
}

/* Masquer le header en mode lecture */
.flipcard-container.reader-mode .flipcard-header {
  display: none;
}

/* Corps de carte ajusté */
.flipcard-container.reader-mode .flipcard-inner {
  height: 320px;
}

/* Faces */
.flipcard-container.reader-mode .flipcard-face {
  padding: 16px;
  display: none;
}

/* Masquer les options en mode lecture */
.flipcard-container.reader-mode .flipcard-content-options {
  display: none;
}

/* Contenu visible par défaut en mode lecture */
.flipcard-container.reader-mode .flipcard-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* Image en mode lecture */
.flipcard-container.reader-mode .flipcard-content img {
  max-height: 250px;
  max-width: 250px;
  object-fit: contain;
}

/* Footer en mode lecture */
.flipcard-container.reader-mode .flipcard-footer {
  height: 32px;
}

/* Bouton flip en mode lecture */
.flipcard-container.reader-mode .flipcard-btn-flip {
  font-size: 12px;
  font-weight: 600;
  color: var(--flipcard-readmode-flipbtn-color);
}

.flipcard-container.reader-mode .flipcard-btn-flip i {
  font-size: 16px;
  color: var(--flipcard-readmode-flipbtn-color);
}

.flipcard-container.reader-mode .flipcard-btn-flip:hover, .flipcard-container.reader-mode .flipcard-btn-flip:hover i {
  color: var(--flipcard-readmode-flipbtn-hover-color);
}

/* Animation de flip */
@keyframes flipIn {
  from {
    opacity: 0;
    transform: rotateY(90deg);
  }
  to {
    opacity: 1;
    transform: rotateY(0deg);
  }
}

.flipcard-container.reader-mode .flipcard-face.active {
  display: flex;
  animation: flipIn 0.3s ease-out;
}

/* État de chargement */
.flipcard-container.reader-mode .flipcard-content.loading {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flipcard-container.reader-mode .flipcard-content.loading::after {
  content: '';
  width: 32px;
  height: 32px;
  border: 3px solid var(--flipcard-reader-flip-text-color);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
`;
